import { FC, HTMLAttributes } from 'react'

export const CancelledIndicator: FC<HTMLAttributes<HTMLSpanElement>> = () => {
  return <span className="text-neutral-normal-lighter text-large font-bold">-</span>
}
